import React, { useEffect, useState } from "react";
import FusionCharts from "fusioncharts";
import TimeSeries from "fusioncharts/fusioncharts.timeseries";
import ReactFC from "react-fusioncharts";
import axios from "axios";
// import { useQuery } from "react-query";

ReactFC.fcRoot(FusionCharts, TimeSeries);

const jsonify = (res) => res.json();
const dataFetch = fetch(
  "https://s3.eu-central-1.amazonaws.com/fusion.store/ft/data/disabling-time-navigator-data.json"
).then(jsonify);
const schemaFetch = fetch(
  "https://s3.eu-central-1.amazonaws.com/fusion.store/ft/schema/disabling-time-navigator-schema.json"
).then(jsonify);

const dataSource = {
  navigator: {
    enabled: 0,
  },
  caption: {
    text: "Footfall count in Vega Store",
  },
  yaxis: [
    {
      plot: "Footfall",
      plottype: "line",
      title: "Count",
    },
  ],
};
const TimeSeriesGraph = () => {
  const [timeseriesDs, settimeseriesDs] = useState({
    type: "timeseries",
    renderAt: "container",
    width: "600",
    height: "400",
    dataSource,
  });

  function onFetchData() {
    Promise.all([dataFetch, schemaFetch]).then((res) => {
      const data = res[0];
      const schema = res[1];
      const fusionTable = new FusionCharts.DataStore().createDataTable(
        data,
        schema
      );
      const timeseriesDss = Object.assign({}, timeseriesDs);
      timeseriesDss.dataSource.data = fusionTable;

      settimeseriesDs(timeseriesDss);
    });
  }

  useEffect(() => {
    onFetchData();
  }, []);

  return (
    <div>
      {timeseriesDs.dataSource.data ? <ReactFC {...timeseriesDs} /> : "loading"}
    </div>
  );
};

export default TimeSeriesGraph;
